import { requestAPI } from '@api/base'

export async function getFormsAPI() {
  return await requestAPI('forms')
}

export async function getFormAPI(id: string) {
  return await requestAPI(`forms/${id}`)
}
